import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export default function QuizPage() {
    const { quizId } = useParams();
    const [error, setError] = useState('');

    useEffect(() => {
        // Programmatic fetch has Accept: */* — CRA proxy forwards it to the backend.
        // document.write() then replaces the React app entirely with the quiz HTML.
        fetch(`/quiz/${quizId}`)
            .then(r => {
                if (!r.ok) return Promise.reject('Quiz not found or has expired.');
                return r.text();
            })
            .then(html => {
                document.open();
                document.write(html);
                document.close();
            })
            .catch(err => setError(String(err)));
    }, [quizId]);

    if (error) {
        return (
            <div style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center',
                justifyContent: 'center', height: '100vh', fontFamily: 'system-ui, sans-serif',
                background: '#f9fafb', color: '#111827',
            }}>
                <div style={{ fontSize: 48, marginBottom: 16 }}>📭</div>
                <h2 style={{ fontWeight: 800, marginBottom: 8 }}>Quiz Not Found</h2>
                <p style={{ color: '#6b7280' }}>{error}</p>
            </div>
        );
    }

    return (
        <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            height: '100vh', background: '#f9fafb', fontFamily: 'system-ui, sans-serif',
        }}>
            <div style={{ textAlign: 'center', color: '#6b7280' }}>
                <div style={{
                    width: 40, height: 40, border: '3px solid #dc2626',
                    borderTopColor: 'transparent', borderRadius: '50%',
                    animation: 'spin 0.8s linear infinite', margin: '0 auto 12px',
                }} />
                <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                Loading quiz…
            </div>
        </div>
    );
}
